import React, {useEffect, useRef, useState} from 'react';
import useAxiosIntercept from "../../hooks/useAxiosIntercept";
import useAuth from "../../hooks/useAuth";

function BrandList(props) {
    const {auth} = useAuth();
    const axiosPrivate = useAxiosIntercept();
    const [brandDetails, setBrandDetails] = useState([]);
    const [modelDetails, setModelDetails] = useState([]);
    const [variantDetails, setVariantDetails] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState(props.selectedBrand ? props.selectedBrand : {});
    const [selectedModel, setSelectedModel] = useState(props.selectedModel ? props.selectedModel : {});
    const [selectedVariant, setSelectedVariant] = useState(props.selectedVariant ? props.selectedVariant : {});
    const [active, setActive] = useState(0);
    const ref = useRef(true);
    // const modelVariantRef = useRef(false);
    const input1Ref = useRef(null);
    const input2Ref = useRef(null);
    const input3Ref = useRef(null);

    const getBrandList = async () =>{
        try{
            let url = process.env.REACT_APP_VEHICLE_BRAND_LIST_URL;
            if(auth.partner_id){
                url = url + '&partner_id=' + auth.partner_id;
            }
            const response =  await axiosPrivate.get(url);
            if(response?.status == 200){
                if(response?.data?.status){
                    if(response?.data?.response?.data){
                        setBrandDetails(response.data.response.data.brand_details);
                        props.setBrandList(response.data.response.data.brand_details);
                    }
                }
                else{

                }
            }
        }
        catch(error){
            console.log(error);
        }
    }

    const getVehicleModel = async () =>{
        try{
            let url = process.env.REACT_APP_VEHICLE_BRAND_MODEL_VARIANT_URL;
            url = url + "&brand_id="+selectedBrand.id;
            const response =  await axiosPrivate.get(url);
            if(response?.status == 200){
                if(response?.data?.status){
                    if(response?.data?.response?.data){
                        setModelDetails(response.data.response.data.models);
                        // setBrandDetails(response.data.response.data.brand_details);
                    }
                }
                else{

                }
            }
        }
        catch(error){
            console.log(error);
        }
    }

    const getVehicleVariant = async () =>{
        try{
            let url = process.env.REACT_APP_VEHICLE_BRAND_MODEL_VARIANT_URL;
            url = url + "&brand_id="+selectedBrand.id+"&model_id="+selectedModel.id+"&variants=true";
            const response =  await axiosPrivate.get(url);
            if(response?.status == 200){
                if(response?.data?.status){
                    if(response?.data?.response?.data){
                        setVariantDetails(response.data.response.data.models);
                        // setBrandDetails(response.data.response.data.brand_details);
                    }
                }
                else{

                }
            }
        }
        catch(error){
            console.log(error);
        }
    }
    useEffect(()=>{
        if(selectedBrand.id){
            getVehicleModel();
        }
    },[selectedBrand])

    useEffect(()=>{
        if(selectedModel.id){
            getVehicleVariant();
        }
    },[selectedModel])

    useEffect(()=>{
        if(ref.current){
            ref.current = false;
            getBrandList();
        }
    },[])
    return (
        <>
            <div className="fieldGroup">
                <label>Select EV brand</label>
                <div className="multiOption">
                    {/*<div className={showDrop ? "selectBox fullW open" : "selectBox fullW"} onClick={()=>{setShowDrop(prev => !prev)}}>*/}
                    <div className={active == 1 ? "selectBox fullW open" : "selectBox fullW"} onClick={(active)=>{setActive((prevState)=>{if(prevState==0){return 1} else{return  0}})}}>
                        {   selectedBrand.id == null?
                            <p>
                            Select Brand{" "}
                            <i className="material-symbols-rounded grey">expand_more</i>
                            </p>
                            :
                            <p>
                                {selectedBrand.name}{" "}
                                <i className="material-symbols-rounded grey">expand_more</i>
                            </p>
                        }
                        <div className="selectDrop customScroll hFix">
                            <ul className="dropMenu" ref={input1Ref}
                            //     style={{
                            //     height: "200px",
                            //     overflowY: "scroll"
                            // }}
                            >
                                { brandDetails && brandDetails.map((data)=>{
                                    return(
                                        <li key={data.id} className={selectedBrand.id == data.id ? "selected" : ""} onClick={()=>{setSelectedBrand({"id": data.id, "name": data.name}); props.setBrand({"id": data.id, "name": data.name}); setSelectedModel({}); props.setModel({}); setSelectedVariant({}); props.setVarint({}); }}>
                                            <a>
                                                {data.name}
                                                {data.id == selectedBrand.id && <i className="material-symbols-rounded">done</i>}
                                            </a>
                                        </li>
                                    )
                                })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                {props.brandMessage &&
                    <div>
                        <span className="error">
                            <span className="material-symbols-rounded error mt-xs fill">
                                info
                            </span>
                            {props.brandMessage}
                        </span>
                </div>}
            </div>
            <div className="fieldGroup">
                <label>Select EV model</label>
                <div className="multiOption">
                    {/*<div className={showDrop ? "selectBox fullW open" : "selectBox fullW"} onClick={()=>{setShowDrop(prev => !prev)}}>*/}
                    <div className={active == 2 ? "selectBox fullW open" : "selectBox fullW"} onClick={(active)=>{if(selectedBrand.id){setActive((prevState)=>{if(prevState==0){return 2} else{return  0}})}}}>
                        {   selectedModel.id == null?
                            <p>
                                Select Model{" "}
                                <i className="material-symbols-rounded grey">expand_more</i>
                            </p>
                            :
                            <p>
                                {selectedModel.name}{" "}
                                <i className="material-symbols-rounded grey">expand_more</i>
                            </p>
                        }
                        <div className="selectDrop customScroll hFix">
                            <ul className="dropMenu" ref={input2Ref}
                            //     style={{
                            //     height: "170px",
                            //     overflowY: "scroll"
                            // }}
                            >
                                { modelDetails &&
                                    modelDetails.map((data)=>{
                                    return(
                                        <li key={data.id} className={selectedModel.id == data.id ? "selected" : ""} onClick={()=>{setSelectedModel({"id":data.id,"name": data.name}); props.setModel({"id":data.id,"name": data.name}); setSelectedVariant({}); props.setVarint({});}}>
                                            <a>
                                                {data.name}
                                                {data.id == selectedModel.id && <i className="material-symbols-rounded">done</i>}
                                            </a>
                                        </li>
                                    )
                                })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                {props.modelMessage &&
                    <div>
                        <span className="error">
                            <span className="material-symbols-rounded error mt-xs fill">
                                info
                            </span>
                            {props.modelMessage}
                        </span>
                    </div>}
            </div>
            <div className="fieldGroup">
                <label>Select EV variant</label>
                <div className="multiOption">
                    {/*<div className={showDrop ? "selectBox fullW open" : "selectBox fullW"} onClick={()=>{setShowDrop(prev => !prev)}}>*/}
                    <div className={active == 3 ? "selectBox fullW open" : "selectBox fullW"} onClick={(active)=>{if(selectedModel.id){setActive((prevState)=>{if(prevState==0){return 3} else{return  0}})}}}>
                        {   selectedVariant.id == null?
                            <p>
                                Select Variant{" "}
                                <i className="material-symbols-rounded grey">expand_more</i>
                            </p>
                            :
                            <p>
                                {selectedVariant.name}{" "}
                                <i className="material-symbols-rounded grey">expand_more</i>
                            </p>
                        }
                        <div className="selectDrop customScroll hFix">
                            <ul className="dropMenu" ref={input2Ref}
                                //     style={{
                                //     height: "170px",
                                //     overflowY: "scroll"
                                // }}
                            >
                                { variantDetails &&
                                    variantDetails.map((data)=>{
                                    return(
                                        data?.variants &&
                                        data.variants.map((item)=>{
                                            return(
                                                <li key={item.id} className={selectedVariant.id == item.id ? "selected" : ""} onClick={()=>{setSelectedVariant({"id": item.id,"name":item.name}); props.setVarint({"id": item.id,"name":item.name});}}>
                                                    <a>
                                                        {item.name}
                                                        {item.id == selectedVariant.id && <i className="material-symbols-rounded">done</i>}
                                                    </a>
                                                </li>)
                                        })
                                    )
                                })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                {props.variantMessage &&
                    <div>
                        <span className="error">
                            <span className="material-symbols-rounded error mt-xs fill">
                                info
                            </span>
                            {props.variantMessage}
                        </span>
                    </div>}
            </div>

        </>
    );
}

export default React.memo(BrandList);